module.exports = __webpack_public_path__ + "static/media/4.76f2e534.png";